import { RequestServiceGet } from "./services-mia/RequestServiceGet";

export const getUserCredentials = async () => {
  if (
    localStorage.getItem("hooliToken") &&
    localStorage.getItem("sessionId")
  ) {
    return {
      hooliToken: localStorage.getItem("hooliToken"),
      sessionId: localStorage.getItem("sessionId"),
      merchantId: localStorage.getItem("merchantId"),
      merchantRZ: localStorage.getItem("merchantRZ"),
      merchantNombre: localStorage.getItem("merchantNombre"),
      merchantCUIT: localStorage.getItem("merchantCUIT"),
    };
  }
  const allowTemporal =
    process.env.REACT_APP_ALLOW_TEMPORAL_SESSION
  if (allowTemporal) {
    console.log("ALLOW_TEMPORAL_SESSION is  true");
    let userCredentials;
    try {
      userCredentials = await RequestServiceGet({
        service: "TemporalSession",
        params: {
          merchantId: 14,
          usuarioId: 5963,
          // merchantId: 1,
          // usuarioId: 0,
        },
      });
    } catch (err) {
      console.log(`Error: ${err}`);
    }
    if (!userCredentials || !(userCredentials?.length > 0)) {
      console.log(`Fetch failed`);
    }
    localStorage.setItem("hooliToken", userCredentials[0].hooliToken);
    localStorage.setItem("sessionId", userCredentials[0].sessionId);
    localStorage.setItem("merchantId", 23);
    localStorage.setItem("merchantRZ", "Policia de la Provincia de Santa Fe");
    localStorage.setItem("merchantNombre", "Policia de la Provincia de Santa Fe");
    localStorage.setItem("merchantCUIT", "30-71512361-2");

    const credentials = {
      hooliToken: userCredentials[0].hooliToken,
      sessionId: userCredentials[0].sessionId,
      merchantId: 23,
      merchantRZ: "Policia de la Provincia de Santa Fe",
      merchantNombre: "Policia de la Provincia de Santa Fe",
      merchantCUIT: "30-71512361-2",
    };
    return credentials;
  }
  return null;
};
